import * as angular from 'angular';

class NetworkPointBundleCreateHarmonizationCtrl implements ng.IController {
    constructor() {}

    public bundleRequest: BundleChangeRequestDto;
    public readonly: boolean;

    $onInit() {
        if (!this.bundleRequest.newHarmonizationScope) {
            this.bundleRequest.newHarmonizationScope = 'NONE';
        }
    }
}

angular.module('app').component('pkpNetworkPointBundleCreateHarmonization', {
    controller: NetworkPointBundleCreateHarmonizationCtrl,
    template:
        require('app/network-point-bundle/network-point-bundle-create-harmonization.component.html'),
    bindings: {
        form: '=',
        readonly: '<',
        bundleRequest: '='
    }
});
